<template>
  <v-app
    id="playposit-dashboard"
    :class="[currentPageClass]"
  >
    <Snackbar></Snackbar>
    <el-dialog
      :visible.sync="dialogOpen"
      lock-scoll
      :width="dialogWidth"
      :close-on-click-modal="false"
      class="background"
    >
      <Popover
        id="dash-popovers"
        v-if="dialogOpen"
        tabindex="-1">
      </Popover>
    </el-dialog>

    <div
      v-if="(
        userDataLoaded
        && !simpleDash
        && !dashLoading
      )"
      id="dash"
    >
      <div v-if="!isRouterView">
        <div id="side-nav-layout" v-if="showNavigation">
          <SideNav v-if="!embedded"></SideNav>
        </div>
        <div
          id="main-view"
          :class="{
            embeddedClass: embedded && !passbackLinking,
            embeddedPassbackClass: embedded && passbackLinking,
            googleClassroomStyle: isGoogleClassroom,
          }"
        >
          <LTIAlertIcon v-if="LTIlaunch" />
          <div
            v-if="showNavigation"
            id="breadcrumb-layout"
          >
            <BreadcrumbHeader></BreadcrumbHeader>
          </div>
          <div id="tabs-layout" ref="tab" tabindex="-1" v-if="showNavigation">
            <Tabs></Tabs>
          </div>
          <div id="router">
            <router-view />
          </div>
        </div>
      </div>
      <div v-else id="router">
        <router-view />
      </div>
    </div>
    <PlaypositOffline :readyToInject="userDataLoaded" />
    <CustomLtiDash v-if="isCustomDash"></CustomLtiDash>
    <div v-else>
      <Greyscreen v-if="greyscreen"></Greyscreen>
      <SlideOutLarge v-if="slideOutLarge.toggle"></SlideOutLarge>
      <SimpleDash v-if="simpleDash"></SimpleDash>
      <Loader v-if="(dashLoading || !userDataLoaded)"></Loader>
    </div>
  </v-app>
</template>

<script>

// Plugins / Libraries:
import {
  mapState,
  mapGetters,
  mapActions,
  mapMutations
} from 'vuex';
import _ from 'lodash';
import { decode } from 'js-base64';
import storejs from 'store';
import sanitizeHtml from 'sanitize-html';
const dumpPlugin = require('store/plugins/dump');
import moment from 'moment';
import axios from 'axios';
const parser = require('ua-parser-js');
import { BroadcastChannel } from 'broadcast-channel';
import {
  PlayPositBroadcastChannels,
  PlayPositBroadcastChannelEventNames,
} from '@BroadcastChannels';

// Custom Components:
import Snackbar from '@/components/Snackbar';
import SideNav from '@/components/SideNav';
import BreadcrumbHeader from '@/components/BreadcrumbHeader';
import Tabs from '@/components/Tabs';
import SlideOutLarge from '@/components/SlideoutLarge';
import Loader from '@/components/Loader';
import Popover from '@/components/Popover';
import Greyscreen from '@/components/Greyscreen'; // new and improved
import SimpleDash from '@/components/SimpleDash';
import LTIAlertIcon from '@/components/LTIAlertIcon';
import CustomLtiDash from '@/components/modal-views/CustomLtiDash';

import {
  LTI_LAUNCH_ENDPOINTS,
  LTI11_LAUNCH_MESSAGE_TYPES,
  LTI13_LAUNCH_MESSAGE_TYPES,
  LTI_RENDER_PATHS,
  PLAYPOSIT_LMB_LAUNCH_ENDPOINTS,
  PLAYPOSIT_PHP_ENDPOINTS,
} from '@Constants';

storejs.addPlugin(dumpPlugin);

/*
  I am putting this comment here so that it can be edited which will cause the auto-builder to build out this microservice. Currently, if you're working on a component inside /express/components/
  and you don't change any microservice files, the autobuilder will not build them out and the changes you made to
  the component will not be applied.

  If this number is 1, change it to 0 and vice-versa: 1
*/

export default {
  name: 'dash',
  components: {
    SideNav,
    BreadcrumbHeader,
    Greyscreen,
    SlideOutLarge,
    Snackbar,
    Tabs,
    Loader,
    Popover,
    LTIAlertIcon,
    SimpleDash,
    CustomLtiDash,
  },
  data() {
    return {
      adminRefresh: false,
      urlDataRoute: '',
      keyboardFocus: false,
      className: 'LMS Course',
      showHelp: false,
      legacyDashBroadcastChannel: null,
      ltiLaunchData: null,
      ltiLaunchDataTick: 0,
    };
  },
  computed: {
    ...mapState('instructors', [
      'embedded',
      'queryParamsInstructors',
      ]),
    ...mapState([
      'isRouterView',
      'permittedProquestPaths',
      'lti13Launch',
    ]),
    ...mapGetters([
      'dashModal',
      'dashLoading', // defaults to true,  turned off in getDashInitialData or in simpleDashToggle
      'slideOutLarge',
      'slideOut',
      'instructorData',
      'activeView',
      'routerView',
      'learnerData',
      'adminPermission',
      'instructorPermission',
      'learnerPermission',
      'passbackLinking',
      'primaryAccount',
      'userDataLoaded',
      'studentArchived',
      'stateDataLoaded',
      'username',
      'classPickerToggle',
      'dialogShow',
      'popoverToggles',
      'LTIlaunch',
      'LTIdata',
      'bluescreenData', // if watcher shows that bluescreenData has props trigger a bluescreen
      'greyscreen', // the new one for strayer
      'breadcrumbs',
      'simpleDash',
      'simpleDashData',
      'simpleDashType',
      'simpleDashReload',
      'instructorType',
      'pro',
      'free',
      'school',
      'phpApiPrefix',
      'nodeApiPrefix',
      'urlToken',
      'LMSdata',
      'isProquestUser',
      'ltiLaunchPath', // determines which LTI routes to use.
    ]),
    ...mapGetters('instructors', [
      'activeViewInstructor',
      'filterSearch',
    ]),
    ...mapGetters('learners', [
      'activeViewLearners',
    ]),
    ...mapGetters('admin', [
      'activeViewAdmin',
      'refreshDataAdmin',
      'schoolsWithChangedDefaultView',
      'queryParamsAdmin',
    ]),
    stateDataTokenWatcher: function() {
      return [this.stateDataLoaded, this.instructorData.token, this.learnerData.token];
    },
    url: function() {
      return this.$route.fullPath;
    },
    dialogWidth: function() {
      return window.innerWidth <= 800 ? `${window.innerWidth - 75}px` : '800px';
    },
    dialogOpen: {
      get() {
        return this.dialogShow.dash || this.dashModal !== null;
      },
      set(value) {
        this.$set(this.dialogShow, 'dash', value);
        this.$store.commit('setDashModal', null);
      },
    },
    isGoogleClassroom() {
      return (
        this.$route.name === 'googleClassPicker' ||
        this.$route.name === 'googleAssignmentPicker' ||
        this.$route.name === 'googleStudentSignIn'
      );
    },
    isCustomDash() {
      return this.$route.name === 'customLtiDash';
    },
    showNavigation() {
      return (
        !this.isGoogleClassroom
        && !this.queryParamsAdmin?.isProquest
        && !this.queryParamsInstructors?.isProquest
      );
    },
    currentPageClass() {
      let path = this.$route.path;
      if (path.startsWith('/dash/')) path = path.slice(6);
      return `${path.toSlug()}-page`;
    },
  },
  methods: {
    ...mapActions([
      'getUserData',
      'setupAjax',
      'getServerUrl',
    ]),
    ...mapActions('canvas', [
      'canvasCheckErrors',
      'convertCanvasCode'
    ]),
    ...mapMutations([
      'setDashLoading',
      'setDashModal',
      'setLti13Launch',
      'setUserAgent',
      'handleDialogOpen',
      'setBluescreenData',
      'setPassbackLinking',
      'updatePermittedProquestPaths',
    ]),
    ...mapMutations('instructors', [
      'setEmbedded',
      'setInitialView',
    ]),
    ...mapMutations('learners', [
      'setInitialSectionId',
    ]),
    enableBluescreen(props) {
      this.$enablePlaypositErrorScreen({
        vertical: true,
        active_color: this.$vuetify.theme.primary,
        base_color: this.$vuetify.theme.secondary,
        inactive_color: this.$vuetify.theme.tertiary,
        title: _.has(props, 'title') ? sanitizeHtml(props.title) : 'Error',
        subtitle: _.has(props, 'subtitle') ? sanitizeHtml(props.subtitle) : '',
        code: _.has(props, 'code') ? sanitizeHtml(props.code) : '',
        text: _.has(props, 'text') ? sanitizeHtml(props.text) : '',
        icon: _.has(props, 'icon') ? sanitizeHtml(props.icon) : 'error',
        buttons: _.has(props, 'buttons') ? props.buttons : [],
      });
    },
    setEmptyQueryParams() {
      const missingParams = {};
      if (!_.has(this.$route, 'query.search')) {
        missingParams.search = '';
      }
      if (!_.has(this.$route, 'query.page')) {
        missingParams.page = 1;
      }
      if (!_.has(this.$route, 'query.per_page')) {
        missingParams.per_page = 20;
      }
      if (!_.has(this.$route, 'query.sort')) {
        missingParams.sort = '';
      }
      if (!_.has(this.$route, 'query.lms_class')) {
        missingParams.lms_class = false;
      }
      if (!_.has(this.$route, 'query.lms_launch')) {
        missingParams.lms_launch = false;
      }
      if (!_.has(this.$route, 'query.lmb_bulb')) {
        missingParams.lmb_bulb = '';
      }
      this.$store.commit('instructors/setEmbedded', true);
      this.$store.commit('instructors/setQueryParams', missingParams);
    },
    handleDialogClose: function(event) {
      //find if table and selected data need to be reset on close
      let reset = false;
      if (
        (this.popoverToggles.confirm &&
          (this.dialogShow.data.type === 'reset' ||
            this.dialogShow.data.type === 'lmbreset' ||
            this.dialogShow.data.type === 'move')) ||
        this.popoverToggles.moveMenu ||
        (this.popoverToggles.remove && this.activeViewInstructor === 'Learners')
      ) {
        reset = true;
      }

      this.dialogShow.dash = false;
      this.dialogShow.data = {};

      this.popoverToggles.mobileWarning = false;
      this.popoverToggles.addMenu = false;
      this.popoverToggles.moveMenu = false;
      this.popoverToggles.graphMenu = false;
      this.popoverToggles.export = false;
      this.popoverToggles.importStatus = false;
      this.popoverToggles.addVideo = false;
      this.popoverToggles.monitor = false;
      this.popoverToggles.copyMenu = false;
      this.popoverToggles.editMenu = false;
      this.popoverToggles.shareMenu = false;
      this.popoverToggles.assignMenu = false;
      this.popoverToggles.remove = false;
      this.popoverToggles.preview = false;
      this.popoverToggles.bulbInfo = false;
      this.popoverToggles.lti = false;
      this.popoverToggles.ltiSync = false;
      this.popoverToggles.joinClass = false;
      this.popoverToggles.profile = false;
      this.popoverToggles.confirm = false;
      this.popoverToggles.interaction = false;
      this.popoverToggles.bulbAnalytics = false;
      this.popoverToggles.lmb = false;
      this.popoverToggles.lmbEdit = false;
      this.popoverToggles.shareLearner = false;
      this.popoverToggles.addSchool = false;
      this.popoverToggles.editSchool = false;
      this.popoverToggles.groups = false;
      this.popoverToggles.addInstructors = false;
      this.popoverToggles.editInstructors = false;
      this.popoverToggles.adminFilterMenu = false;
      this.popoverToggles.snapshot = false;
      this.popoverToggles.broadcast = false;
      this.popoverToggles.addFolder = false;
      this.popoverToggles.editFolder = false;
      this.popoverToggles.addToFolder = false;
      this.popoverToggles.copyFolder = false;
      this.popoverToggles.shareFolder = false;
      this.popoverToggles.coursePermission = false;
      this.popoverToggles.copyClassicBulbs = false;
      this.$store.commit('learners/resetClassSearch');
      this.$store.commit('setLtiSync', null);

      if (reset) {
        this.$store.commit('instructors/setSelectedData', []);
        this.$store.commit('instructors/refreshData');
      }
    },
    applyDashboardPreferences() {
      if (
        !this.$inDevEnvironment() &&
        this.instructorData?.id &&
        storejs.get(`teacher${this.instructorData.id}DashboardPreference`) !== 'old' &&
        (this.school?.config?.permissions?.includes('defaultToNewDashboard') ||
          storejs.get(`teacher${this.instructorData.id}DashboardPreference`) === 'new')
      ) {
        window.location.replace(`${this.$getServerUrl()}dashboard?token=${this.instructorData?.token}`);
      }
    },
    async getInitialDashData() {
      document.body.addEventListener('mousedown', this.toggleFocus);
      document.body.addEventListener('keydown', this.toggleFocus);

      let query = this.decodeAllQueryProperties(this.$route.query);
      let name = this.$route.name;

      if (name === 'bluescreen') return this.enableBluescreen(query);

      await this.getToken({ query, name });
      const weVideoVideoId = this.$getURLParameter('weVideoVideoId');
      if (weVideoVideoId) {
        return window.location.href = `${this.nodeApiPrefix}/designer/?bulb_id=new&video_type=wevideo&video_type_id=${weVideoVideoId}&token=${this.urlToken}`;
      }
      if (_.get(query, 'sectionId')) this.setInitialSectionId(parseInt(query.sectionId, 10));

      if (name === 'lti') {
        // simpleDash launch (Bulb unlink success, bulb relink)
        await this.getUserData();
        this.$store.commit('simpleDashToggle', {
          activate: true,
          type: 'lti',
          data: query,
        });
      } else if (name === 'oauth') {
        if (this.$route.params.type === 'canvas') {
          // loading spinner while we convert the code into a token
          await this.getUserData();
          // [ ] this should probably just be a vuex canvas action.
          const errors = await this.canvasCheckErrors(query);
          if (!errors) {
            this.enableBluescreen({
              title: 'Generating Canvas Token',
              subtitle: 'Generating Canvas API token. Please wait',
              icon: 'loop',
            });
            await this.convertCanvasCode({
              oauthCode: this.$route.query.code,
              oauthState: this.$route.query.state,
            });
          }
        }
      } else {
        // standard dash launch
        await this.getUserData();
        //if query params include LTI launch data, store data, get LMS data, get LMS assignment status, and redirect to simple dash
        if (
          [
            LTI_LAUNCH_ENDPOINTS.LTI_11,
            LTI_LAUNCH_ENDPOINTS.LTI_13,
          ].includes(query.launch_endpoint)
        ) {
          // teacher or student bulb launch
          //if lti launch, set data, get LMS type

          /**
           * [✅] currently used by:
           * - getContent
           * - setContent
           * - checkLink
           * - unlinkBulb
           */
          this.setLti13Launch(query.launch_endpoint === LTI_LAUNCH_ENDPOINTS.LTI_13);
          this.$store.commit('setLTIuser', query);

          await this.$store.dispatch('getLmsData', {
            // get data stored with PP about user's lms
            /**
             * Important differences for LTI 1.3:
             *      LTI 1.1          ===     LTI 1.3
             * - `query.consumer_pk` === `query.client_id`
             */
            consumerPk: query.consumer_pk,
            sectionId: this.LTIdata.section_id || query.section_id,
          });

          //If the custom URL must be defined in school.config if the route is for custom dash
          if (
            this.isCustomDash
            && _.get(this, 'school.config.customLtiDashUrl', '').length === 0
          ) {
            this.enableBluescreen({
              title: 'Custom Content Failed',
              text: 'The custom picker is not enabled for the school. Please contact help@playposit.org for support.',
            });
          }

          if (
            (
              query.isContentItemLaunch == 0
              || query.isContentItemLaunch == 1
            )
            && query.resource_link_id
            && [
              LTI11_LAUNCH_MESSAGE_TYPES.BasicLtiLaunchRequest,
              LTI11_LAUNCH_MESSAGE_TYPES.BasicLaunch,
              LTI13_LAUNCH_MESSAGE_TYPES.LtiResourceLinkRequest,
            ].includes(query.message_type)
          ) {
            //get lti assignment content data
            this.$store.dispatch('getContent', {
              resource_link_id: query.resource_link_id,
              consumer_pk: query.consumer_pk,
              ...(this.lti13Launch && { deploymentId: query.deploymentId }),
              token: this.urlToken,
            });
          } else if (
            query.isContentItemLaunch == 0
            && !query.resource_link_id
          ) {
            let data = {
              title: 'Set Link',
              msg: 'No content has been attached to this link',
              secondary: 'Learn More',
              secondarylink: 'learnMore',
              primary: 'setLink',
              primarylink: 'exit',
              exit: 'myBulbs',
              exitText: 'Enter PlayPosit',
            };
            if (
              query.grade_enable == 0
              && this.LMSdata.type !== 'd2l'
            ) {
              data.alert = true;
              data.alertText = 'Grade export not supported for this type of launch.';
            }
            this.$store.commit('simpleDashToggle', { activate: true, type: 'lti', data });
          } else {
            this.enableBluescreen({
              title: 'Integration Failed',
              text:
                'Unable to pull the necessary data from the Learning Management System. Please contact help@playposit.org for support.',
            });
          }
        } else if (
          [
            PLAYPOSIT_LMB_LAUNCH_ENDPOINTS.LTI_11_LMB_LAUNCH,
            PLAYPOSIT_LMB_LAUNCH_ENDPOINTS.LTI_13_LMB_LAUNCH,
            PLAYPOSIT_LMB_LAUNCH_ENDPOINTS.LMB_LAUNCH
          ].includes(query.launch_endpoint)
        ) {
          // Student launching dash to complete learner made bulb
          if ([PLAYPOSIT_LMB_LAUNCH_ENDPOINTS.LTI_13_LMB_LAUNCH].includes(query.launch_endpoint)) {
            this.setLti13Launch(true);
          }
          try {
            const lmb = await this.$store.dispatch('learners/loadBulbAttemptLMB', {
              bulbId: query.bulb_id,
              sectionId: query.section_id,
              resourceLinkId: query?.resource_link_id,
            });
            this.$store.commit('learners/setQueryParams', {
              lms_launch: true,
            });
            this.$store.commit('simpleDashToggle', {
              activate: true,
              type: 'lmb',
              data: lmb.data,
            });
            if (
              [
                PLAYPOSIT_LMB_LAUNCH_ENDPOINTS.LTI_11_LMB_LAUNCH,
                PLAYPOSIT_LMB_LAUNCH_ENDPOINTS.LTI_13_LMB_LAUNCH
              ].includes(query.launch_endpoint)
            ) {
              // Not really sure why we are setting this in local storage...
              this.$store.commit('setLTIuser', query);
              storejs.set('lti-student', lmb.data); // LTI lmb launch, set lti data
            }
          } catch (e) {
            this.enableBluescreen({
              title: 'Unable to load LMB',
              subtitle: '',
              text: 'This assignment may have been deleted by the instructor.',
            });
          }
        } else {
          //if no LTI data and query params for LMS launch is false, remove old LTI data from local storage
          if (!query.lms_launch) {
            storejs.remove('lti');
            storejs.remove('lti-student');
          }
          this.setDashLoading(false); // no lti/simpleDash lauch turn off loading here, otherwise simpleDash toggle will turn off the dashLoading var
        }
      }
      const parsedUA = new parser.UAParser().getResult();
      this.setUserAgent(parsedUA);
      if (
        _.get(parsedUA.browser, 'name') === 'IE'
        || _.get(parsedUA.browser, 'name') === 'IEMobile'
      ) {
        this.$store.commit('triggerSnackbar', {
          text: 'This browser version is not supported. Try again on another browser.',
          color: 'red',
          timeout: 0,
          action_text: 'Chrome Recommended',
          action: 'chrome',
        });
      }
      if (_.get(parsedUA, 'device.type') === 'mobile') {
        if (window.innerHeight > window.innerWidth) this.$store.commit('triggerMobileWarning');
      }

      this.applyDashboardPreferences();
      this.injectCss();
      this.getPermittedProquestPaths();
      this.verifyProquestPathPermissions();
    },
    injectCss() {
      if (
        !this.school
        || !this?.school?.permissionKeys?.includes('enableDashboardCssInjection')
        || document.getElementById('playposit-custom-dashboard-styles')
      ) return;
      const linkElement = document.createElement('link');
      linkElement.id = 'playposit-custom-dashboard-styles';
      linkElement.setAttribute('rel', 'stylesheet');
      linkElement.setAttribute('href', this.school.cssInjection);

      /* attach to the document head */
      document.getElementsByTagName('head')[0].appendChild(linkElement);
    },
    getToken({ query, name } = {}) {
      /**
       * parse token out of url or from store.js
       */
      let token = null;
      if (query.token) {
        //look for token in query- if initial load
        token = query.token;
      } else {
        //if no token in query- look for token in storejs
        if (name === 'instructor' || name === 'admin') {
          //if
          let pp_token = storejs.get('pp_instructor_token');
          if (pp_token) token = pp_token;
        } else if (name === 'learner') {
          let pp_token_learner = storejs.get('pp_learner_token');
          if (pp_token_learner) token = pp_token_learner;
        } else {
          //if no name given- search for pp_primary
          let primary = storejs.get('pp_primary');
          //look up token based on primary account
          if (primary === 'instructor') {
            let pp_token = storejs.get('pp_instructor_token');
            if (pp_token) token = pp_token;
          } else if (primary === 'learner') {
            let pp_token_learner = storejs.get('pp_learner_token');
            if (pp_token_learner) token = pp_token_learner;
          }
        }
      }
      if (token) {
        this.setupAjax();
        this.$store.commit('setToken', token);
      } else {
        // redirect to blue screen to login again
        this.enableBluescreen({
          title: 'Not Authorized',
          text: 'Please login to PlayPosit to generate an authorization token.',
          buttons: [
            {
              text: 'Login',
              action: 'https://www.playposit.com/login',
            },
          ],
        });
      }
    },
    /**
     * This function honestly makes me want to cry...
     */
    async stateFromUrl() {
      //pulls activeView, school name, and query params from url
      // [ ] does this need to happen if we have triggered the simpleDash
      let name = this.$route.name;
      let params = this.$route.params;
      let query = this.$route.query;
      
      if (name === 'classpicker') {
        this.$store.commit('simpleDashToggle', { activate: true, type: 'classpicker', data: {} });
        return;
      }
      //set breadcrumb and payload from URL
      if (query.breadcrumbs) {
        //if breadcrumbs exist- parse to array
        let breadcrumbs = [];
        try {
          breadcrumbs = JSON.parse(decode(query.breadcrumbs));
        } catch (e) {
          try {
            breadcrumbs = JSON.parse(atob(query.breadcrumbs));
          } catch (ee) {
            try {
              breadcrumbs = JSON.parse(query.breadcrumbs);
            } catch (eee) {
              breadcrumbs = [];
            }
          }
        }
        let gradebook = [];
        if (query.gradebook) {
          //if gradebook breadcrumbs exists- parse to array
          try {
            gradebook = JSON.parse(decode(query.gradebook));
          } catch (e) {
            try {
              gradebook = JSON.parse(atob(query.gradebook));
            } catch (ee) {
              gradebook = JSON.parse(query.gradebook);
            }
          }
        }

        //loop through and identify all necessary payloads
        let payloads = [];
        breadcrumbs.forEach(item => {
          if (item.payload != '') payloads.push(item.payload);
        });
        gradebook.forEach(item => {
          if (item.payload != '') payloads.push(item.payload);
        });

        //create missing payloads for gradebook, interactions, student bulb attempts, and learners gradebook
        let newPayloads = {};
        payloads.forEach(item => {
          if (item === 'Gradebook') {
            let section_name = breadcrumbs[1].text;
            newPayloads['Gradebook'] = {
              activeView: 'Classes',
              activeViewRoute: 'Gradebook',
              breadcrumb: [
                { text: 'Classes', payload: 'Classes' },
                { text: section_name, payload: '' },
                { text: 'Gradebook', payload: 'Gradebook' },
              ],
              queryParams: { section_id: parseInt(query.section_id, 10) },
              route: 'instructor',
            };
          }
          if (item === 'Interactions') {
            let interaction_name = gradebook[0].text;
            newPayloads['Interactions'] = {
              activeView: 'Classes',
              activeViewRoute: 'Interactions',
              breadcrumb: [{ text: interaction_name, payload: '' }],
              queryParams: { section_id: parseInt(query.section_id, 10), bulb_id: parseInt(query.bulb_id, 10) },
              route: 'instructor',
            };
          }
          if (item === 'Bulbs') {
            let section_name = breadcrumbs[1].text;
            newPayloads['Bulbs'] = {
              activeView: 'Classes',
              activeViewRoute: 'Bulbs',
              breadcrumb: [
                { text: 'Classes', payload: 'Classes' },
                { text: section_name, payload: '' },
                { text: 'Bulbs', payload: 'Bulbs' },
              ],
              queryParams: { section_id: parseInt(query.section_id, 10) },
              route: 'instructor',
            };
          }
          if (item === 'Folders') {
            let folder_name = breadcrumbs[1].text;
            newPayloads['Folders'] = {
              activeView: 'Folders',
              activeViewRoute: 'Folders',
              breadcrumb: [{ text: 'Folders', payload: '' }],
              queryParams: {},
              route: 'instructor',
            };
          }
          if (item === 'Folder') {
            let folder_name = breadcrumbs[1].text;
            newPayloads['Folder'] = {
              activeView: 'Folders',
              activeViewRoute: 'Folder',
              breadcrumb: [
                { text: 'Folders', payload: 'Folders' },
                { text: folder_name, payload: '' },
              ],
              queryParams: { folder_id: parseInt(query.folder_id, 10) },
              route: 'instructor',
            };
          }
          if (item === 'Student-Bulb-Attempts') {
            let student_name = gradebook[0].text;
            newPayloads['Student-Bulb-Attempts'] = {
              activeView: 'Classes',
              activeViewRoute: 'Student-Bulb-Attempts',
              breadcrumb: [{ text: student_name, payload: '' }],
              queryParams: { section_id: parseInt(query.section_id, 10), student_id: parseInt(query.student_id, 10) },
              route: 'instructor',
            };
          }
          if (item === 'Learner-Gradebook') {
            let classes_name = breadcrumbs[0].text;
            let class_name = breadcrumbs[1].text;
            newPayloads['Learner-Gradebook'] = {
              activeView: 'Learner',
              activeViewRoute: 'Gradebook',
              breadcrumb: [
                { text: classes_name, payload: 'Learner' },
                { text: class_name, payload: '' },
              ],
              queryParams: { section_id: parseInt(query.section_id, 10) },
              route: 'learner',
            };
          }
          if (item === 'Learner-Bulbs') {
            let classes_name = breadcrumbs[0].text;
            let class_name = breadcrumbs[1].text;
            newPayloads['Learner-Bulbs'] = {
              activeView: 'Learner',
              activeViewRoute: 'Bulbs',
              breadcrumb: [
                { text: classes_name, payload: 'Learner' },
                { text: class_name, payload: '' },
              ],
              queryParams: { section_id: parseInt(query.section_id, 10) },
              route: 'learner',
            };
          }
          if (item === 'Learner') {
            let student_classes = breadcrumbs[0].text;
            newPayloads['Learner'] = {
              activeView: 'Learner',
              activeViewRoute: 'Classes',
              breadcrumb: [{ text: student_classes, payload: '' }],
              queryParams: {},
              route: 'learner',
            };
          }
          if (item === 'LMB') {
            let bulb_name = gradebook[0].text;
            newPayloads['LMB'] = {
              route: 'instructor',
              activeView: 'Classes',
              activeViewRoute: 'Learner-Made-Bulb',
              queryParams: { section_id: parseInt(query.section_id, 10), bulb_id: parseInt(query.bulb_id, 10) },
              breadcrumb: [{ text: bulb_name, payload: '' }],
            };
          }
        });
        //update breadcrumbs with all payloads
        this.$store.commit('updateBreadCrumbs', [breadcrumbs, newPayloads]);
      }
      if (query.passback_linking) {
        this.setPassbackLinking(query.passback_linking === 'true' ? true : false);
      }
      //set active color to vuetify theme
      this.$set(this.$vuetify.theme, 'primary', this.school.active_color);
      if (
        name === null
        || name === 'dashboard'
        || name === 'lti'
      ) {
        storejs.set('url', []);
        //on initial app load
        //add admin in front of this
        if (
          this.primaryAccount === 'Instructor'
          || (
            this.primaryAccount === 'Admin'
            && this.LTIlaunch
            && !this.schoolsWithChangedDefaultView.includes(this.school.id)
          )
        ) {
          if (Boolean(query.isTeacherBeingImpersonated)) {
            sessionStorage.setItem('impersonatedTeacherId', this.instructorData.id);
          }
          //if instructor, call for class data
          // [ ] refactor to pass object with props {activeView: 'My-Bulbs', routerView: 'instructor'}
          this.$store.commit('setNav', ['My-Bulbs', 'instructor']);
          // [ ] refactor this to just pass the string "My-Bulbs"
          this.$store.commit('instructors/setActiveView', ['My-Bulbs']);
          // [ ] refactor to pass object with props {breadcrumb: [{text, payload}], payload: }
          this.$store.commit('updateBreadCrumbs', [[{ text: 'My Bulbs', payload: '' }], {}]);
          this.$store.dispatch('instructors/getTableData');
          this.$store.dispatch('instructors/updateUrl');
        } else if (this.primaryAccount === 'Learner') {
          this.$store.commit('setNav', ['Learner', 'learner']);
          this.$store.commit('learners/setActiveView', ['Classes']);
          this.$store.commit('updateBreadCrumbs', [
            [{ text: `${this.learnerData.firstName}'s Classes`, payload: '' }],
            {},
          ]);
          this.$store.dispatch('learners/getTableData');
          this.$store.dispatch('learners/updateUrl');
        } else if (this.primaryAccount === 'Admin') {
          if (this.schoolsWithChangedDefaultView.includes(this.school.id)) {
            this.$store.commit('setNav', ['Administration', 'admin']);
            this.$store.commit('admin/setActiveView', ['Treeview']);
          } else if (!this.LTIlaunch) {
            this.$store.commit('setNav', ['Administration', 'admin']);
            this.$store.commit('admin/setActiveView', ['Snapshot']);
          }
          this.$store.commit('updateBreadCrumbs', [[{ text: 'Administration', payload: '' }], {}]);
          this.$store.dispatch('admin/getSnapshotData');
          this.$store.dispatch('admin/updateUrl');
        }

        this.$store.commit('stateDataLoadedToggle');
      } else if (name === 'admin') {
        //if admin
        //find save url data or set new url data for url link
        let array = storejs.get('url') ? storejs.get('url') : [];
        array.push({
          path: this.$route.fullPath,
          data: { name: 'admin', params: this.$route.params, query: this.$route.query },
        });
        storejs.set('url', array);

        //if instructor, sets main nav, sets instructor nav
        this.$store.commit('setNav', [params.activeView, name]);
        this.$store.commit('admin/setActiveView', [params.secondaryView]);

        let adminQueryParams = {
          page: query.page != '' ? parseInt(query.page, 10) : query.page,
          per_page: query.per_page != '' ? parseInt(query.per_page, 10) : query.per_page,
          school_id: query.school_id != 0 ? parseInt(query.school_id, 10) : 0,
          search: query.search,
          sort: query.sort,
          isProquest: query.isProquest !== '' ? Boolean(query.isProquest) : query.isProquest,
        };
        this.$store.commit('admin/setQueryParams', adminQueryParams);
        this.$store.commit('stateDataLoadedToggle');
      } else if (name === 'instructor') {
        //find save url data or set new url data for url link
        let array = storejs.get('url') ? storejs.get('url') : [];
        array.push({
          path: this.$route.fullPath,
          data: { name: 'instructor', params: this.$route.params, query: this.$route.query },
        });
        storejs.set('url', array);
        if (Boolean(query.isTeacherBeingImpersonated)) {
          sessionStorage.setItem('impersonatedTeacherId', this.instructorData.id);
        }

        //if instructor, sets main nav, sets instructor nav
        this.$store.commit('setNav', [params.activeView, name]);
        this.$store.commit('instructors/setActiveView', [params.secondaryView]);
        //creates instructor query params
        let instructorQueryParams = {
          page: query.page != '' ? parseInt(query.page, 10) : query.page,
          per_page: query.per_page != '' ? parseInt(query.per_page, 10) : query.per_page,
          search: query.search,
          sort: query.sort,
          section_id: query.section_id != '' ? parseInt(query.section_id, 10) : query.section_id,
          bulb_id: _.get(query, 'bulb_id', '') != '' ? parseInt(query.bulb_id, 10) : '',
          interaction_id: query.interaction_id != '' ? parseInt(query.interaction_id, 10) : query.interaction_id,
          student_id: query.student_id != '' ? parseInt(query.student_id, 10) : query.student_id,
          folder_id: query.folder_id != '' ? parseInt(query.folder_id, 10) : query.folder_id,
          subfolder_id: query.subfolder_id != '' ? parseInt(query.subfolder_id, 10) : query.subfolder_id,
          lms_class: query.lms_class === 'false' ? false : true,
          lmb_bulb: query.lmb_bulb != '' ? parseInt(query.lmb_bulb, 10) : query.lmb_bulb,
          lmb_section: query.lmb_section != '' ? parseInt(query.lmb_section, 10) : query.lmb_section,
          playlistAssign: query.playlistAssign != '' ? parseInt(query.playlistAssign, 10) : '',
          isProquest: query.isProquest !== '' ? Boolean(query.isProquest) : query.isProquest,
          lti13Launch: query.lti13Launch !== '' ? Boolean(query.lti13Launch) : query.lti13Launch,
        };

        //sets legacy to true if premade legacy
        if (
          params.secondaryView === 'Premade-Bulbs-Legacy'
          || params.secondaryView === 'My-Community-Legacy'
        ) {
          this.filterSearch.legacy = true;
        }

        if (query.copyFolderId) {
          this.handleDialogOpen({
            type: 'confirm',
            data: {
              type: 'copyfolder',
              data: {
                id: query.copyFolderId,
                name: query.copyFolderName,
              },
            },
          });
          this.$store.dispatch('instructor/updateUrl');
        }

        if (query.lms_launch == 'true') {
          let data = (
            query
            || this.ltiLaunchData
            || storejs.get('lti')
          );
          this.setLti13Launch((query.lti13Launch !== '' ? Boolean(query.lti13Launch) : query.lti13Launch));

          //check if lti data exists
          if (
            data &&
            Object.keys(data).length > 0
          ) {
            this.ltiLaunchDataTick = 0;
            if (query.monitor) {
              data.monitor = true;
            }
            if (query.peer_review) {
              data.peer_review === 'true' ? true : false;
            }
            //set data
            this.$store.commit('setLTIuser', data);

            //find token
            let token = null;
            if (query.token) {
              //look for token in query- if initial load
              token = query.token;
            } else {
              //if no token in query- look for token in storejs
              let pp_token = storejs.get('pp_instructor_token');
              if (pp_token) token = pp_token;
            }

            if (token) {
              await this.$store.dispatch('getLmsData', {
                // get data stored with PP about user's lms
                consumerPk: data?.consumer_pk || query.consumer_pk,
                sectionId: this.LTIdata.section_id,
              });
              if (
                data.isContentItemLaunch == 0 &&
                data.resource_link_id &&
                data.message_type === LTI11_LAUNCH_MESSAGE_TYPES.BasicLtiLaunchRequest
              ) {
                //if non picker launch- get content data
                let obj = { resource_link_id: data.resource_link_id, consumer_pk: data.consumer_pk, token: token };
                if (data.monitor) {
                  obj.monitor = true;
                }
                this.$store.dispatch('getContent', obj); // get data from PP related to this LTI assignment
              }
              if (
                data.isContentItemLaunch == 0
                && !data.resource_link_id
              ) {
                let dataDash = {
                  title: 'Set Link',
                  msg: 'No content has been attached to this link',
                  secondary: 'Learn More',
                  secondarylink: 'learnMore',
                  primary: 'setLink',
                  primarylink: 'exit',
                  exit: 'myBulbs',
                  exitText: 'Enter PlayPosit',
                };
                if (data.grade_enable == 0) {
                  dataDash.alert = true;
                  dataDash.alertText = 'Grade export is not supported via toolbar launch.';
                }
                this.$store.commit('simpleDashToggle', { activate: true, type: 'lti', data: dataDash });
              }
            } else {
              //if no token- redirect to bluescreen
              this.enableBluescreen({
                title: 'Not Authorized',
                text: 'Please launch assignment again to generate an active authorization token.',
              });
            }
          } else {
            try {
              this.ltiLaunchDataTick += 1;
              console.log({
                error: 'Integration Data Missing',
                store: storejs.dump(),
              });
              dataLayer.manualLog({
                error: 'Integration Data Missing',
                lti: storejs.get('lti') || null,
              });
            } catch (err) {
              console.log('Error Logging Integration Data Missing', err);
              dataLayer.manualLog({
                error: 'Integration Data Missing logging error',
                err,
              });
            }
            if (this.ltiLaunchDataTick === 2) {
              this.enableBluescreen({
                title: 'Integration Data Missing',
                text:
                  'Please return to your LMS assignment and refresh the page. Contact PlayPosit support if this issue persists.',
              });
            }
          }
        }

        //sets gradebook breadcrumbs, instructor query params
        if (query.gradebook) {
          let finalGradebook;
          try {
            finalGradebook = JSON.parse(decode(query.gradebook));
          } catch (e) {
            try {
              finalGradebook = JSON.parse(atob(query.gradebook));
            } catch (ee) {
              finalGradebook = JSON.parse(query.gradebook);
            }
          }
          this.$store.commit('instructors/setGradebookBreadcrumbs', finalGradebook);
        }
        this.$store.commit('instructors/setQueryParams', instructorQueryParams);
        // If it has embed=true - set up for simple gradebook
        if (_.get(this.$route, 'query.embed', false) === 'true') {
          this.setEmptyQueryParams();
        }
        this.$store.commit('stateDataLoadedToggle');
      } else if (name === 'learner') {
        //find save url data or set new url data for url link
        let array = storejs.get('url') ? storejs.get('url') : [];
        array.push({
          path: this.$route.fullPath,
          data: { name: 'learner', params: this.$route.params, query: this.$route.query },
        });
        storejs.set('url', array);

        //sets main nav and learner active nav
        this.$store.commit('setNav', [params.activeView, name]);
        this.$store.commit('learners/setActiveView', [params.secondaryView]);

        //sets learner query params
        let learnerQueryParams = {
          page: query.page != '' ? parseInt(query.page, 10) : query.page,
          per_page: query.per_page != '' ? parseInt(query.per_page, 10) : query.per_page,
          search: query.search,
          sort: query.sort,
          section_id: query.section_id != '' ? parseInt(query.section_id, 10) : query.section_id,
          bulb_id: query.bulb_id != '' ? parseInt(query.bulb_id, 10) : query.bulb_id,
          lmb_bulb: query.lmb_bulb != '' ? parseInt(query.lmb_bulb, 10) : query.lmb_bulb,
          lmb_section: query.lmb_section != '' ? parseInt(query.lmb_section, 10) : query.lmb_section,
          lms_launch: query.lms_launch,
        };

        //overide breadcrumb if new token
        this.breadcrumbs[0].text = `${this.learnerData.firstName}'s Classes`;
        this.$store.dispatch('learners/updateUrl');

        if (query.lms_launch == 'true') {
          let data = storejs.get('lti-student');
          this.$store.commit('simpleDashToggle', { activate: true, type: 'lmb', data: data });
        }
        //sets learner gradebook breadcrumbs and query params
        this.$store.commit('learners/setGradebookBreadcrumbs', JSON.parse(query.gradebook));
        this.$store.commit('learners/setQueryParams', learnerQueryParams);
        this.$store.commit('stateDataLoadedToggle');
      }
    },
    listenToBrowser: function() {
      window.addEventListener('popstate', this.listenToBack);
      window.addEventListener('storage', this.listenToStorage);
    },
    listenToStorage: function(event) {
      if (event.key === 'new_bulb_created' && this.activeViewInstructor === 'My-Bulbs') {
        this.$store.dispatch('instructors/getTableData');
      }

      if (event.key === 'new_bulb_created' && this.simpleDash && this.simpleDashType === 'lmb') {
        //update lti storage if started
        let data = this.LTIlaunch ? storejs.get('lti-student') : this.simpleDashData;
        data.complete = 'true';
        data.completion_time = moment().format('MMM DD, YYYY');
        if (this.LTIlaunch) storejs.set('lti-student', data);
        this.$store.commit('simpleDashToggle', { activate: true, type: 'lmb', data: data });
        this.$store.commit('simpleDashReloadToggle', true);
      }
    },
    listenToBack: function(event) {
      //when popstate event occurs
      if (event) {
        //loop through array of saved states
        let array = storejs.get('url');
        let data;
        array.forEach(hist => {
          //if current path matches saved path, load matching data
          if (hist.path === this.url) {
            data = hist.data;
          }
        });
        if (data.name === 'instructor') {
          //if instructor, sets main nav, sets instructor nav
          this.$store.commit('setNav', [data.params.activeView, data.name]);
          this.$store.commit('instructors/setActiveView', [data.params.secondaryView]);

          //creates instructor query params
          let instructorQueryParams = {
            page: data.query.page != '' ? parseInt(data.query.page, 10) : data.query.page,
            per_page: data.query.per_page != '' ? parseInt(data.query.per_page, 10) : data.query.per_page,
            search: data.query.search,
            sort: data.query.sort,
            section_id: data.query.section_id != '' ? parseInt(data.query.section_id, 10) : data.query.section_id,
            bulb_id: data.query.bulb_id != '' ? parseInt(data.query.bulb_id, 10) : data.query.bulb_id,
            interaction_id:
              data.query.interaction_id != '' ? parseInt(data.query.interaction_id, 10) : data.query.interaction_id,
            student_id: data.query.student_id != '' ? parseInt(data.query.student_id, 10) : data.query.student_id,
            folder_id: data.query.folder_id != '' ? parseInt(data.query.folder_id, 10) : data.query.folder_id,
            subfolder_id:
              data.query.subfolder_id != '' ? parseInt(data.query.subfolder_id, 10) : data.query.subfolder_id,
            lms_class: data.query.lms_class,
            lmb_bulb: data.query.lmb_bulb != '' ? parseInt(data.query.lmb_bulb, 10) : data.query.lmb_bulb,
            lmb_section: data.query.lmb_section != '' ? parseInt(data.query.lmb_section, 10) : data.query.lmb_section,
          };
          this.$store.commit('instructors/setQueryParams', instructorQueryParams);
          this.$store.commit('instructors/clearAllFiltersNoReload');

          //sets gradebook breadcrumbs and main breadcrumbs
          if (data.query.breadcrumbs) {
            let breadcrumbs = [];
            try {
              breadcrumbs = JSON.parse(decode(data.query.breadcrumbs));
            } catch (e) {
              try {
                breadcrumbs = JSON.parse(atob(data.query.breadcrumbs));
              } catch (ee) {
                try {
                  breadcrumbs = JSON.parse(data.query.breadcrumbs);
                } catch (eee) {
                  breadcrumbs = [];
                }
              }
            }
            this.$store.commit('updateBreadCrumbs', [breadcrumbs, {}]);
          }
          if (data.query.gradebook) {
            let finalGradebook;
            try {
              finalGradebook = JSON.parse(decode(data.query.gradebook));
            } catch (e) {
              try {
                finalGradebook = JSON.parse(atob(data.query.gradebook));
              } catch (ee) {
                finalGradebook = JSON.parse(data.query.gradebook);
              }
            }
            this.$store.commit('instructors/setGradebookBreadcrumbs', finalGradebook);
          }
          //get data
          if (
            this.activeViewInstructor != 'Premade-Bulbs' &&
            this.activeViewInstructor != 'My-Community' &&
            this.activeViewInstructor != 'Premade-Bulbs-Legacy'
          ) {
            this.$store.dispatch('instructors/getTableData');
          } else {
            this.$store.dispatch('instructors/getPremadeTableData', {});
          }
        } else if (data.name === 'learner') {
          //sets main nav and learner active nav
          this.$store.commit('setNav', [data.params.activeView, data.name]);
          this.$store.commit('learners/setActiveView', [data.params.secondaryView]);

          //sets learner query params
          let learnerQueryParams = {
            page: data.query.page != '' ? parseInt(data.query.page, 10) : data.query.page,
            per_page: data.query.per_page != '' ? parseInt(data.query.per_page, 10) : data.query.per_page,
            search: data.query.search,
            sort: data.query.sort,
            section_id: data.query.section_id != '' ? parseInt(data.query.section_id, 10) : data.query.section_id,
            bulb_id: data.query.bulb_id != '' ? parseInt(data.query.bulb_id, 10) : data.query.bulb_id,
            lmb_bulb: data.query.lmb_bulb != '' ? parseInt(data.query.lmb_bulb, 10) : data.query.lmb_bulb,
            lmb_section: data.query.lmb_section != '' ? parseInt(data.query.lmb_section, 10) : data.query.lmb_section,
          };
          this.$store.commit('learners/setQueryParams', learnerQueryParams);
          //sets learner gradebook breadcrumbs and breadcrumbs
          if (data.query.breadcrumbs) this.$store.commit('updateBreadCrumbs', [JSON.parse(data.query.breadcrumbs), {}]);
          this.$store.commit('learners/setGradebookBreadcrumbs', JSON.parse(data.query.gradebook));
          //get data
          if (this.keyboardFocus) {
            this.setLearnerFocus();
          }
          this.$store.dispatch('learners/getTableData');
        } else if (data.name === 'admin') {
          this.$store.commit('setNav', [data.params.activeView, data.name]);
          this.$store.commit('admin/setActiveView', [data.params.secondaryView]);

          let adminQueryParams = {
            page: data.query.page != '' ? parseInt(data.query.page, 10) : data.query.page,
            per_page: data.query.per_page != '' ? parseInt(data.query.per_page, 10) : data.query.per_page,
            school_id: data.query.school_id != 0 ? parseInt(data.query.per_page, 10) : 0,
            search: data.query.search,
            sort: data.query.sort,
          };
          this.$store.commit('admin/setQueryParams', adminQueryParams);
          this.$store.dispatch('admin/getTableData');
        }
      }
    },
    toggleFocus: function(event) {
      if (event.type === 'keydown' && event.key === 'Tab') {
        this.keyboardFocus = true;
      }

      if (event.type === 'mousedown') {
        this.keyboardFocus = false;
      }
    },
    setLearnerFocus: function() {
      if (this.keyboardFocus) {
        if (this.activeViewLearners === 'Bulbs') {
          setTimeout(() => {
            let bulbs = Array.from(document.getElementsByClassName('bulb-tab'));
            bulbs[0].focus();
          }, 500);
        }

        if (this.activeViewLearners === 'Gradebook') {
          setTimeout(() => {
            let gradebooks = Array.from(document.getElementsByClassName('gradebook-tab'));
            gradebooks[0].focus();
          }, 500);
        }

        if (this.activeViewLearners === 'Student-Interaction') {
          setTimeout(() => {
            let answers = Array.from(document.getElementsByClassName('answer-tab'));
            answers[0].focus();
          }, 500);
        }

        if (this.activeViewLearners === 'Classes') {
          setTimeout(() => {
            let classes = Array.from(document.getElementsByClassName('classname'));
            if (classes[0]) classes[0].focus();
          }, 500);
        }
      }
    },
    initializeAxiosInterceptors() {
      axios.interceptors.response.use(response => {
        const storeVersion = storejs.get('playpositApplicationVersion');
        const serverVersion = _.get(response, 'headers[x-playposit-application-version]');
        if (!storeVersion && serverVersion) storejs.set('playpositApplicationVersion', serverVersion);
        if (storeVersion && serverVersion && this.$isNewerVersion(storeVersion, serverVersion)) {
          storejs.set('playpositApplicationVersion', serverVersion);
          this.$store.commit('triggerSnackbar', {
            text: 'You are using an outdated version of PlayPosit. Please clear your cache and refresh the page.',
            color: 'warning',
            timeout: 0,
            action_text: 'Refresh',
            action: 'refresh',
          });
        }
        return response;
      });
    },
    async customLtiLinkBulbMessageReceived(event) {
      try {
        if (_.get(event, 'data')) {
          const message = JSON.parse(event.data);

          // Check to make sure postMessage from iFrame has the custom link attempt
          if (message.type === 'playposit__custom_lti_link_bulb') {
            if (await this.isBulbAlreadyLinked(message.bulbId)) {
              this.$store.commit('triggerSnackbar', {
                text: 'Bulb has already been linked to another assignment.',
                color: 'red',
                timeout: 6000,
              });
            } else {
              this.$store.commit('triggerSnackbar', {
                text: 'Successfully linked content!',
                color: 'green',
                timeout: 1000,
              });
              setTimeout(() => {
                const disableTitleAutofill = this?.school?.permissionKeys?.includes('disableCanvasAssignmentTitleAutofill');
                if (this.lti13Launch) {
                  return window.location.replace(
                    PLAYPOSIT_PHP_ENDPOINTS.LTI_13.contentItemSelectionRequestPlacement({
                      phpApiPrefix: this.phpApiPrefix,
                      teacherId: this?.instructorData?.id,
                      contentId: message.bulbId,
                      contentTitle: (!disableTitleAutofill) ? this?.dialogShow?.data?.name : '',
                      placement: 'iframe',
                      contentTitle: (
                        this?.dialogShow?.data?.name
                        || 'Lexis custom Linked bulb'
                      ),
                      renderPath: 'play2',
                    })
                  );
                }
                return window.location.replace(
                  PLAYPOSIT_PHP_ENDPOINTS.LTI_11.contentItemSelectionRequestPlacement({
                    phpApiPrefix: this.phpApiPrefix,
                    teacherId: this.instructorData.id,
                    lessonId: message.bulbId,
                    consumerPk: this?.LTIdata?.consumer_pk,
                    placement: 'iframe',
                    lessonTitle: (!disableTitleAutofill )? this?.dialogShow?.data?.name : '',
                    renderPath: LTI_RENDER_PATHS.Play2,
                    enableGrading: 1,
                  })
                );
              }, 1000);
            }
          }
        }
      } catch (err) {
        if (err.message !== 'Unexpected token o in JSON at position 1') {
          dataLayer.errorLog({
            msg: `Unable to catch post message. err: ${JSON.stringify(err)}`,
            location: 'Dash: customLtiLinkBulbMessageReceived',
          });
        }
      }
    },
    async isBulbAlreadyLinked(bulbId) {
      const {
        section_id: sectionId,
      } = this.LTIdata;
      const checkLink = await axios.get(
        `${this.nodeApiPrefix}/ltidash/checklink/?content_id=${bulbId}&section_id=${sectionId}&timestamp=${moment()}`,
        {
          headers: {
            Authorization: `Bearer ${this.instructorData.token}`,
          },
        }
      );
      return (checkLink?.data?.linked || checkLink?.data?.data?.linked);
    },
    getPermittedProquestPaths() {
      /*
        These navigation restrictions only apply to two kinds of users:

        1. Any non-admin teacher associated with a school that has the "isProquestSchool" permission.
        2. Any student that belongs to a class owned by a teacher who meets the first condition.
      */
      if (
        !this.isProquestUser
        || parseInt(sessionStorage.getItem('impersonatedTeacherId'), 10) === this.instructorData.id
        || this?.instructorData?.isAdmin
      ) {
        return;
      }
      /*
        Proquest students are not allowed anywhere in the dash so we throw an error screen
        no matter what.
      */
      if (this.learnerData?.isProquestStudent) return this.updatePermittedProquestPaths(['-']);
      /*
        Non-admin Proquest teachers will only be allowed to access these paths.
      */
      this.updatePermittedProquestPaths([
        '/dash/instructor/Classes/Interactions',
        '/dash/instructor/Classes/Single-Interaction',
        '/dash/instructor/Classes/Student-Interaction',
      ]);
    },
    verifyProquestPathPermissions() {
      if (!this.permittedProquestPaths?.length) return;
      const standardizedPath = this.$route.path?.endsWith('/') ? this.$route.path.slice(0, -1)  : this.$route.path;
      if (!this.permittedProquestPaths.includes(standardizedPath)) {
        this.enableBluescreen({
          title: 'Not Authorized',
          text: 'You are not permitted to view this part of the website.',
        });
      } else {
        this.$disablePlaypositErrorScreen();
      }
    },
    decodeAllQueryProperties(queryObject) {
      for (const property in queryObject) {
        queryObject[property] = decodeURIComponent(queryObject[property]);
        // Need to do this for LTI 1.1 backwards compatibility :(
        queryObject[_.snakeCase(property)] = queryObject[property];
      }
      return queryObject;
    },
    initializeLegacyDashBroadcastChannel() {
      this.legacyDashBroadcastChannel = new BroadcastChannel(PlayPositBroadcastChannels.legacyDashBroadcastChannel);
      this.initializeroadcastChannelEvents();
    },
    initializeroadcastChannelEvents() {
      this.legacyDashBroadcastChannel.onmessage = (event) => {
        try {
          if (event?.name === PlayPositBroadcastChannelEventNames.LTI_LAUNCH) {
            this.ltiLaunchData = event?.data;
          }
        } catch (error) {
          // do nothing for now...
        }
      }
    },
  },
  watch: {
    $route: 'verifyProquestPathPermissions',
    bluescreenData: {
      handler(n, o) {
        if (_.has(n, 'title')) {
          // new bluescreen title, trigger it.
          this.enableBluescreen(n);
          // reset bluescreen
          this.setBluescreenData({});
        }
      },
      deep: true,
    },
    userDataLoaded: {
      handler: function(newValue, oldValue) {
        if (newValue) {
          this.stateFromUrl();
        }
      },
    },
    stateDataTokenWatcher: {
      handler: function(val, oldVal) {
        //watch if state data loaded from url
        if (val[0] && JSON.stringify(val) != JSON.stringify(oldVal)) {
          //if true
          if (val[1] && this.routerView === 'instructor') {
            //if instructor view/ calls for classes data
            if (
              this.activeViewInstructor != 'Premade-Bulbs' &&
              this.activeViewInstructor != 'My-Community' &&
              this.activeViewInstructor != 'Premade-Bulbs-Legacy' &&
              this.activeViewInstructor != 'My-Community-Legacy'
            ) {
              this.$store.dispatch('instructors/getTableData');
            } else {
              this.$store.dispatch('instructors/getPremadeTableData', {});
            }
          }
          if (val[1] && this.routerView === 'admin') {
            if (this.activeViewAdmin != 'Snapshot') {
              this.$store.dispatch('admin/getTableData');
            } else {
              this.$store.dispatch('admin/getSnapshotData');
            }
          }
          if (val[2] && this.routerView === 'learner') {
            //if learner, calls for table data
            if (this.activeViewLearners != 'LMB-Monitor') {
              this.$store.dispatch('learners/getTableData');
            } else {
              this.$store.dispatch('learners/getMonitorData');
            }
          }
        }
      },
    },
    dialogOpen: {
      //set focus on popover when open and back to page when closes
      handler: function(val) {
        if (val) {
          let tabElements = document.getElementsByClassName('tabable');
          Array.from(tabElements).forEach(el => {
            el.setAttribute('tabindex', '-1');
            let children = el.childNodes;
            children.forEach(item => {
              if (item.nodeType === 1) {
                item.setAttribute('tabindex', '-1');
              }
            });
          });

          let tabFirstElements = document.getElementsByClassName('tabable-first');
          Array.from(tabFirstElements).forEach(el => {
            el.setAttribute('tabindex', '-1');
            let children = el.childNodes;
            children.forEach(item => {
              if (item.nodeType === 1) {
                item.setAttribute('tabindex', '-1');
              }
            });
          });

          setTimeout(() => {
            let screen = document.getElementsByClassName('v-modal');
            Array.from(screen).forEach(el => {
              el.setAttribute('tabindex', '-1');
            });
          }, 500);
        } else {
          let tabElements = document.getElementsByClassName('tabable');
          Array.from(tabElements).forEach(el => {
            el.setAttribute('tabindex', '0');
            let children = el.childNodes;
            children.forEach(item => {
              if (item.nodeType === 1) {
                item.removeAttribute('tabindex');
              }
            });
          });

          let tabFirstElements = document.getElementsByClassName('tabable-first');
          Array.from(tabFirstElements).forEach(el => {
            el.setAttribute('tabindex', '1');
            let children = el.childNodes;
            children.forEach(item => {
              if (item.nodeType === 1) {
                item.removeAttribute('tabindex');
              }
            });
          });

          this.setLearnerFocus();
        }
      },
    },
    activeViewLearners: {
      //set first focus on each student dash view
      handler: function(val) {
        this.setLearnerFocus();
      },
    },
    ltiLaunchData(newValue, oldValue) {
      if (newValue) {
        this.stateFromUrl();
      }
    },
  },
  mounted() {
    this.listenToBrowser();

    if (_.get(this.$route, 'query.view', false)) this.setInitialView(this.$route.query.view);

    window.addEventListener('message', event => {
      if (
        event.data.archived
        && (
          event.data.user === this.instructorData.id
          || event.data.user === this.learnerData.id
        )
      ) {
        window.location.replace(`${this.phpApiPrefix}/logout`);
      }
    });

    window.addEventListener('message', this.customLtiLinkBulbMessageReceived.bind(this));
  },
  async created() {
    this.initializeLegacyDashBroadcastChannel();
    this.getServerUrl();
    this.initializeAxiosInterceptors();
    if (process.env.NODE_ENV !== 'production') window.vm = this;
    //gets url token at created
    this.getInitialDashData();
  },
  beforeDestroy () {
    this.legacyDashBroadcastChannel.close();
  },
};
</script>

<style lang="scss">
/*App Layout CSS*/
html {
  width: 100vw;
  height: 100vh;
  overflow-y: hidden !important;
  background-color: #fafafa !important;
}

#dash {
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 200px auto;
  overflow-x: auto;
}

#side-nav-layout {
  grid-row: 1/2;
  grid-column: 1/2;
}

#breadcrumb-layout {
  height: 50px;
  width: 100%;
}

#tabs-layout {
  height: 50px;
  width: 100%;
}

#main-view {
  grid-row: 1/2;
  grid-column: 1/3;
  margin-left: 80px;
  min-width: 900px;
  height: 100%;
  width: calc(100vw - 80px);
  display: flex;
  flex-flow: column;
}

#router {
  height: calc(100% - 100px);
  width: 100%;
}

#help-button {
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 0px 12px 24px 0px;
  padding: 0px 0px;
  width: 60px;
  z-index: 100;
}

#help-widget-container {
  display: flex;
  flex-flow: column;
  justify-content: flex-end;
  align-items: center;
  width: 50px;
  height: 100px;
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 0px 12px 70px 0px;
}

/*#hs-beacon div iframe:first-child {*/
/*  display:none;*/
/*}*/

/*#hs-beacon div iframe{*/
/*  margin-right: 50px;*/
/*  margin-bottom: -40px;*/
/*}*/

/*#drift-widget-container iframe{*/
/*  margin: 0px 50px 110px 0px !important;*/
/*}*/

.popover-content-wrapper {
  height: 400px;
  width: 100%;
}

/*css reset*/
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  box-sizing: border-box;
  vertical-align: baseline;
  font-family: Roboto, sans-serif;
  font-weight: 400;
  color: #808080;
  word-break: normal;
}

label {
  margin-bottom: 0px !important;
}

/*Branding Color Classes*/
.branded-background {
  background-color: var(--branding-active-hex) !important;
}
.branded-text {
  color: var(--branding-active-hex) !important;
}

.branded-border {
  border: solid 1px var(--branding-active-hex);
}
.branded-grey {
  color: #858585;
}

.branded-grey div {
  color: #858585;
}

.branded-text span {
  color: var(--branding-active-hex) !important;
}

.white-background {
  background-color: #fff !important;
}

.text-white {
  color: #fff !important;
}
.branded-breadcrumb {
  cursor: pointer !important;
}
.branded-breadcrumb a div {
  color: var(--branding-active-hex) !important;
}
.v-list__group__header--active .v-list__group__header__prepend-icon i {
  color: var(--branding-active-hex) !important;
}

body .primary {
  background-color: var(--branding-active-hex) !important;
  border-color: var(--branding-active-hex) !important;
}

.secondary-background {
  background-color: #ff7a59 !important;
}

/*Accessibility Focus Classes*/
nav:focus {
  outline: solid 2px #fd9727;
}
a:focus {
  outline: solid 2px #fd9727;
}
.tabable:focus {
  outline: solid 2px #fd9727;
}
.tabable-first:focus {
  outline: solid 2px #fd9727 !important;
  outline-offset: -2px;
}
input:focus {
  outline: solid 2px #fd9727 !important;
}
.v-tabs:focus {
  outline: solid 2px #fd9727;
}
button:focus {
  outline: solid 2px #fd9727 !important;
}
.sort-caret:focus {
  outline: solid 2px #fd9727;
}

[data-whatintent='mouse'] :focus,
[data-whatintent='mouse'] *:focus {
  outline: none !important;
  outline-offset: none;
}

/*Generic Classes and specific applications*/
.column {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
}

.center {
  width: 100%;
  height: 100% !important;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
}

.center .v-list__tile {
  width: 100%;
  height: 100%;
}

.row-center {
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
}

.row-right {
  display: flex;
  flex-flow: row;
  align-items: flex-end;
  justify-content: flex-end;
}

.row-space {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
}

.row-around {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-around;
  padding: 16px;
}

.row-start-only {
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: flex-start;
}

.row-start {
  width: 100%;
  height: 50px;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: flex-start;
}

.row-start-small {
  width: 100%;
  height: 40px;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: flex-start;
}

.row-start-start {
  width: 100%;
  height: 40px !important;
  display: flex;
  flex-flow: row;
  align-items: flex-start;
  justify-content: flex-start;
}

.column-space {
  width: 100%;
  height: calc(100vh - 50px);
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}
.column-space-instructor {
  height: calc(100vh - 98px);
}
.row-between div {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-around;
}

.cursor {
  cursor: pointer;
}

.hover:hover {
  background-color: var(--darkerHex) !important;
  cursor: pointer;
}

.hover:hover span {
  color: #fff;
}

.no-hover::before {
  background-color: transparent !important;
}

.hover-white:hover {
  background-color: #fff !important;
  cursor: pointer;
}

.bold {
  font-weight: bold;
}

.small-bold {
  font-size: 1rem;
  font-weight: bold;
}

.full-width {
  width: 100%;
}

.full-height {
  height: 100% !important;
}

/* .full-width  div{
  width: 100%;
} */

/* .full-width input {
  background-color: #f5f5f5;
  padding: 5px;
} */

.text-truncate {
  width: 60px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.margin-right-small {
  margin-right: 10px;
}

/*Vuetify css changes*/
.v-list {
  padding: 0 !important;
}

.v-list__tile__title {
  font-size: 1em;
}

.v-chip {
  border: solid 1px lightgrey;
}

.v-form {
  display: flex;
  flex-flow: row;
  width: 20vw;
}

.refresh .v-icon {
  color: var(--branding-active-hex) !important;
}

.v-snack__content {
  color: #fff !important;
}

.v-input {
  margin-top: 0;
}

.v-card {
  background-color: #fafafa !important;
  box-shadow: none;
}

.v-text-field .v-label {
  max-width: 100%;
}

v-toolbar__content {
  height: 50px !important;
  max-height: 50px;
  padding-top: 0px;
}

.v-input__icon--append i {
  color: var(--branding-active-hex) !important;
}
.v-input__icon--clear i {
  color: var(--branding-active-hex) !important;
}

.v-alert {
  margin: 0 !important;
  padding: 8px;
  height: 50px;
}
.v-input--switch {
  height: 34px;
}

.el-color-dropdown__link-btn {
  display: none !important;
}

.el-color-dropdown__btn {
  background-color: var(--branding-active-hex) !important;
}

.el-color-dropdown__btn span {
  color: white;
}

.elevation-2 {
  box-shadow: none !important;
}

.lmb-peer-review .v-tabs__bar {
  background-color: #757575 !important;
}

/*LTI classes */
.lti-content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
}

.lms-img {
  height: 25px;
  width: 25px;
  min-width: 25px;
}

.lms-img-sm {
  height: 16px;
  width: 16px;
  min-width: 16px;
}

.lms-img-small {
  height: 15px;
  width: 15px;
  position: absolute;
  top: 0;
  right: 0;
}

.lms-assign-warning {
  text-align: center;
  margin-top: -25px !important;
}

.lti-button {
  padding: 4px 12px !important;
  width: 125px !important;
}

/*Table and Element CSS global changes*/
td {
  padding: 0 !important;
}

th {
  padding-top: 0px !important;
}

#lti th {
  padding-top: 12px !important;
}

.el-table th {
  background-color: #fafafa !important;
}

.btn-prev {
  background-color: #fafafa !important;
}

.btn-next {
  background-color: #fafafa !important;
}

.el-pager li {
  background-color: #fafafa !important;
}

.el-pagination {
  z-index: 10 !important;
}

.active {
  color: var(--branding-active-hex) !important;
  cursor: pointer;
}

.active a div {
  color: var(--branding-active-hex) !important;
}

.active-grey {
  text-decoration: underline;
  cursor: pointer;
}

.active-grey a div {
  text-decoration: underline;
}

.el-radio__input.is-checked + .el-radio__label {
  color: var(--branding-active-hex) !important;
}
.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  border-left: 1px solid var(--branding-active-hex) !important;
}

.el-radio__input.is-checked .el-radio__inner {
  border-color: var(--branding-active-hex) !important;
  background: var(--branding-active-hex) !important;
}

.el-dialog__header {
  display: none !important;
}

.el-dialog__body {
  padding: 0 !important;
}

.cell {
  word-break: normal !important;
  white-space: pre-wrap !important;
}

.selectable .cell {
  cursor: pointer;
  color: var(--branding-active-hex) !important;
}

.selectable {
  cursor: pointer;
  color: var(--branding-active-hex) !important;
}

.descSelected .cell .caret-wrapper .descending {
  border-top-color: var(--branding-active-hex) !important;
}

.ascSelected .cell .caret-wrapper .ascending {
  border-bottom-color: var(--branding-active-hex) !important;
}

.noSelected .cell .caret-wrapper .ascending {
  border-bottom-color: lightgrey;
}

.noSelected .cell .caret-wrapper .descending {
  border-top-color: lightgrey;
}

.question-header {
  display: flex !important;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

.question_footer_gradebook {
  min-height: 50px;
  width: 100%;
  background-color: #fff !important;
  display: flex !important;
  flex-flow: row;
  justify-content: center;
  align-items: center;
}

.question_footer {
  min-height: 50px;
  width: 100%;
  background-color: #fff !important;
  display: flex !important;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
}

.question_footer_points {
  width: 80px;
  height: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
}

.question_footer_radio {
  width: 225px;
  height: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
}

.question_footer_radio .el-radio-group {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.question-timestamp {
  font-size: 12px !important;
  line-height: 18px !important;
}

.interaction-header {
  display: flex !important;
  flex-flow: column;
  height: 50px !important;
}

.interaction-question-icon {
  width: 100%;
  height: 100%;
  background-color: rgba(144, 147, 153, 0.1);
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: space-around;
  padding: 0 4px;
}

.interaction-question-icon h5 {
  margin-top: -10px !important;
}

.interaction-header span {
  height: 30px !important;
}

.no-padding {
  padding: 0px !important;
  margin: 0px !important;
}

.no-padding .cell {
  padding: 0px !important;
  margin: 0px !important;
}

.row-height {
  height: 40px !important;
}

.padding {
  padding: 5px !important;
}

.thumbnail {
  width: 100%;
  /*height: 40px;*/
  /*width: auto;*/
  /*max-width: 60px;*/
}
.thumbnail-wrapper {
  position: relative;
  height: 100%;
  cursor: pointer;
  background-size: cover;
  background-position: center;
}

.school-wrapper {
  position: relative;
  height: 100%;
  background-size: contain;
  background-position: center;
}

.thumbnail-wrapper-nonselect {
  position: relative;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.loader {
  width: 100%;
  height: 360px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader-snapshot {
  width: 100%;
  height: 415px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader-snapshot-header {
  width: 100%;
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader-popover {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-screen {
  width: 100%;
  height: 100px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

.v-btn.text-white .v-btn__loading .v-progress-circular {
  color: #fff !important;
}

.el-table__empty-text {
  width: 100%;
  height: 100%;
}

.bulb-tag span {
  color: white;
}

.el-radio-button__inner {
  border-left: 1px solid #dcdfe6 !important;
}

.gradebook-header {
  display: flex !important;
  flex-flow: column;
  justify-content: center;
  align-items: flex-start;
  max-height: 60px;
  padding: 0px !important;
}

.gradebook-header p {
  min-width: 180px;
  margin-bottom: 0px !important;
  text-align: center;
}

.gradebook-name {
  max-height: 40px;
  width: 100%;
  line-height: 20px;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gradebook-date {
  margin-top: 4px;
  width: 100%;
  height: 20px;
  line-height: 16px;
}

/*question display css*/
.answer-display {
  text-align: center;
}

.el-popover {
  padding: 0 !important;
  min-width: 100px !important;
  max-height: 100vh !important;
  z-index: 1300 !important;
  border: none !important;
}

.question_header {
  background-color: var(--branding-active-hex);
  display: flex;
  flex-flow: row;
  justify-content: space-around;
  align-items: center;
  padding: 12px;
}

.question_header span {
  color: white;
}

.time-icon {
  color: white !important;
  margin-right: 10px;
}

.question-popover {
  max-height: 400px;
  overflow-y: auto;
}

.question-format {
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: normal;
  padding: 16px;
  word-wrap: break-word;
  font-size: 18px !important;
  line-height: 28px !important;
}

.question-text {
  width: 100%;
}

.question-iframe {
  width: 373px;
  height: 300px;
}

.learner-question-iframe {
  width: 300px;
  height: 300px;
}

.question-iframe iframe {
  width: 100%;
  height: 100%;
}

.question-modal-iframe {
  width: 100%;
  height: 300px;
}

.question-modal-iframe iframe {
  width: 100%;
  height: 100%;
}

.learner-question-iframe {
  width: 300px;
  height: 300px;
}

.learner-question-iframe iframe {
  width: 100%;
  height: 100%;
}

.question-format ul {
  width: 100%;
  list-style: none;
}

.question-format ul li {
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;
  padding: 5px;
}

.question-format p {
  text-align: left;
}

.question-tag {
  width: 30px;
  height: 30px !important;
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

.feedback {
  align-items: flex-start !important;
  margin-left: 40px;
  font-size: 12px;
  color: hsl(0, 0%, 60%);
}

.dot-incorrect {
  height: 20px;
  width: 20px;
  min-width: 20px;
  border: solid lightgrey 1px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 10px;
}

.dot-correct {
  height: 20px;
  width: 20px;
  min-width: 20px;
  border: solid lightgrey 1px;
  background-color: var(--branding-active-hex) !important;
  border-radius: 50%;
  display: inline-block;
  margin-right: 10px;
}

.dot-selected {
  height: 20px;
  width: 20px;
  min-width: 20px;
  border: solid lightgrey 3px;
  background-color: grey;
  border-radius: 50%;
  display: inline-block;
  margin-right: 10px;
}

.correct-border {
  border-left: 5px solid #4caf50;
  margin-left: 12px;
}

.incorrect-border {
  border-left: 5px solid #f44336;
  margin-left: 12px;
}

.missed-border {
  border-left: 5px solid #ffc107;
  margin-left: 12px;
}

.correct-border span,
.incorrect-border span,
.missed-border span {
  margin-left: 12px;
}

.el-tag {
  margin: 5px 5px !important;
}

.el-tag--info {
  color: #4d4d4d !important ;
  border-color: #808080 !important;
}

.el-tag--clear {
  background-color: transparent !important;
  color: #858585 !important;
  border: none !important;
}

.el-tag--success {
  background-color: #e6f4ea !important;
  border-color: #34a853 !important;
  color: #4d4d4d !important;
}

.el-tag--success i,
.el-tag--warning i,
.el-tag--danger i {
  color: #4d4d4d !important;
}

.fail {
  color: #ea4335 !important;
}
.successful {
  color: #34a853 !important;
}

.el-tag--danger {
  background-color: #fce8e6 !important;
  border-color: #ea4335 !important;
  color: #4d4d4d !important ;
}

.el-tag--warning {
  background-color: #fef7e0 !important;
  border-color: #fbbc04 !important;
  color: #4d4d4d !important;
}

.disabled input {
  color: #858585 !important;
  font-style: italic !important;
}

/*.correct {*/
/*  width: 100%;*/
/*  max-width: 150px;*/
/*  height: 70%;*/
/*  background-color: #4caf50;*/
/*  color: white;*/
/*  word-break: normal;*/
/*  white-space: pre-wrap;*/
/*}*/

/*.incorrect {*/
/*  width: 100%;*/
/*  max-width: 150px;*/
/*  height: 70%;*/
/*  background-color: #f44336;*/
/*  color: white;*/
/*  word-break: normal;*/
/*  white-space: pre-wrap;*/
/*}*/

/*.ungraded {*/
/*  width: 100%;*/
/*  max-width: 150px;*/
/*  height: 70%;*/
/*  background-color: orange;*/
/*  color: white;*/
/*  word-break: normal;*/
/*  white-space: pre-wrap;*/
/*}*/

.student-answers {
  width: 100%;
  max-width: 150px;
  height: 70%;
  word-break: normal;
  white-space: pre-wrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.free-response-answer {
  max-height: 300px;
  flex: 0 1 auto !important;
  overflow-y: auto;
  overflow-x: hidden;
  word-break: normal;
  white-space: pre-wrap;
  text-align: left;
  padding: 10px;
  margin-right: -22px;
}

.explanation {
  padding: 5px;
  margin: -5px;
  border-radius: 5px;
  background-color: orange;
  color: white;
  cursor: pointer;
}

.gradebook-tag {
  width: 55px;
}

.popup {
  max-width: 175px;
  margin: auto;
}

.el-radio-button__inner {
  border-left: 1px solid #dcdfe6 !important;
  padding: 12px 12px !important;
}

.learner-teacher-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: flex-start;
}

.bulbs-tag-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: flex-start;
}

.bulb-name-truncate {
  max-height: 50px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.safari-bulb-name-truncate {
  max-height: 50px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.safari-bulb-name-truncate.admin-media-library {
  max-height: 50px;
  width: 230px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.safari-bulb-name-truncate-folders-table {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edit-tags {
  height: 32px;
  width: 72px;
  margin: 5px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
}

/*Popover Css Classes*/
.width-small {
  width: 446px !important;
}

.padding-left {
  padding-left: 18px;
}

.padding-overall .cell {
  padding: 12px;
}

.padding-left td .cell {
  padding-left: 24px;
}

.row-height-large td .cell {
  padding-top: 10px !important;
}

.padding-right {
  padding-right: 18px;
}

.action-button button,
.action-button-delete button {
  margin: 0;
  width: 100%;
  height: 35px;
}

.action-button .v-btn__content,
.action-button-delete .v-btn__content {
  min-width: 100px;
  height: 35px;
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;
  text-transform: none !important;
  font-size: 13px;
  font-weight: 500;
  line-height: 26px;
}

.action-button button:hover i {
  color: var(--branding-active-hex) !important;
}

.action-button-delete button:hover i {
  color: red !important;
}

.class-button div {
  padding-left: 12px;
}

.no-border {
  height: 55px !important;
}
.no-border td {
  border-bottom: none !important;
}

.subfolder-btn .v-btn__content {
  font-size: 10px !important;
}

.popover-title {
  color: white;
  font-size: 1.08rem;
}

.popover-scroll {
  max-height: 500px;
  overflow-y: auto;
  padding-bottom: 100px;
}

.card-icon {
  display: grid;
  grid-template-columns: 25% 75%;
  grid-template-rows: 100%;
}

.share input[type='text'] {
  margin-top: 14px;
  outline: none !important;
}
.share .v-text-field > .v-input__control > .v-input__slot:before,
.share .v-text-field > .v-input__control > .v-input__slot:after {
  display: none;
}

.student-profile-container {
  max-height: 300px;
  overflow-y: auto;
}

.current-row .cell {
  background-color: var(--lighterHex);
  color: #fff;
}

.v-select__selections {
  width: 1000px;
}

.share-info {
  height: 60px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: flex-start;
}

.el-color-picker__trigger {
  border: none;
}

.center-discussion {
  width: 100%;
  height: 350px !important;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
}
.question-format p {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.5;
}
.discussion-comments {
  height: 100%;
  position: relative;
}

.discussion-comment .comment-content {
  word-wrap: break-word;
  white-space: normal;
}
.comment-name {
  font-size: 14px;
  line-height: 1.1;
  margin: 0;
  font-weight: 700;
}

.discussion-comment .comment-name > span {
  position: relative;
}

.discussion-comment img {
  max-width: 100%;
}

.comment-replies {
  margin-top: 8px;
}

.vue-avatar--wrapper span {
  color: white;
}

.text-truncate-popover {
  width: 650px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.assign-title-width {
  max-width: 450px;
}

.assign-limit {
  min-width: 210px;
}

.assign-limit-label {
  color: #fff !important;
}

.assign-limit .v-progress-linear {
  margin: 8px !important;
}

.join-background td {
  background-color: var(--branding-active-hex) !important;
}

.join-background .cell {
  color: white;
}

.refresh-discussion {
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.refresh-discussion button div i {
  color: rgba(0, 0, 0, 0.54) !important;
}

.bulb-settings-basic {
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 30% 70%;
}

.v-autocomplete__content {
  z-index: 3000 !important;
}

.select-overflow .v-select__selections {
  max-height: 60px;
  overflow-y: auto;
}

.v-alert__dismissible {
  align-self: center !important;
}

.height-60 {
  height: 60px;
}

.display-none {
  display: none;
}

.timezone-assign {
  height: 50px;
  padding: 0px 24px;
  background-color: #fafafa;
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;
}

.assign-class-container {
  width: 100%;
  height: 43px;
}

.assign-class-container div {
  height: 30px;
  padding-left: 18px;
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: flex-start;
}

.assign-dark {
  color: #747579;
}

.assign-light {
  color: #747579;
  font-size: 12px;
  opacity: 0.8;
}

.advanced-section-lmb {
  height: 42px;
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: flex-start;
}

.share-learner-info-container {
  width: 100%;
  height: 100px;
}

.share-learner-info {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
  padding: 5px 24px 0px 24px;
}

.share-learner-info span {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.64);
}

.share-learner-copy-container {
  width: 100%;
  height: 60px;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 24px;
  margin-bottom: 36px;
}

.share-learner-copy-container .v-input {
  flex: none;
}

.share-learner-copy-container .v-input,
.share-learner-copy-container .v-input__control,
.share-learner-copy-container .v-input__slot {
  width: 600px !important;
  height: 40px !important;
  min-height: 40px !important;
}

.share-learner-copy-container .v-input_control:before,
.share-learner-copy-container .v-input__slot:before {
  border: none !important;
}

.share-learner-copy-container input {
  margin-top: 6px !important;
  outline: none !important;
}

.copy-advanced {
  width: 100%;
  background-color: #fff;
  padding: 12px;
}

.school-branding .v-list__tile__title {
  width: 120px !important;
}

.v-list--disabled {
  background-color: #f1f1f1 !important;
}

.instructor-privacy .accent--text {
  color: var(--branding-active-hex) !important;
}

#school-branding-thumbnail {
  width: 200px;
  height: 120px;
  background-color: #fafafa;
}

.import-groups-container {
  width: 100%;
  height: 300px;
  overflow-y: scroll;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
}

.import-groups-container-loaded {
  width: 100%;
  overflow-y: scroll;
  display: flex;
  flex-flow: row;
  height: 100%;
}

.import-tree {
  width: 65%;
}

.instructor-error-msg {
  color: #f44336;
}

.no-left-border {
  border-left: none !important;
}

.v-btn-toggle.independent-btn-toggle .v-btn:not(.v-btn--disabled) {
  opacity: 1;
}

/*Side Nav CSS*/
#side-nav {
  width: 80px;
  height: 100vh;
  position: fixed;
  z-index: 999;
}

#side-nav aside {
  transform: translateX(0px) !important;
}

#nav {
  background-color: var(--branding-active-hex) !important;
}

.avatar {
  height: 50px !important;
  max-height: 50px;
  padding-top: 0px !important;
}

.divider {
  border-top: solid var(--lighterHex) 1px;
}

.active-div {
  background-color: var(--darkerHex) !important;
}

.active-icon {
  background-color: #fff;
  color: var(--branding-active-hex) !important;
  border-radius: 100%;
  padding: 4px;
  max-width: 32px;
}

.active-dash {
  background-color: hsla(360, 100%, 100%, 0.7);
  padding: 8px 2px;
  border-radius: 5px;
}

.side-nav-title {
  color: #fff !important;
  width: 170px !important;
}

.headway {
  width: 15px;
  height: 15px;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

.groupInput {
  color: var(--branding-active-hex) !important;
}
/*Tabs CSS*/

#tabs {
  height: 50px;
  width: 100%;
  background-color: #fafafa !important;
  padding: 0px 24px;
}

/*Breadcrumb CSS*/
#breadcrumb-header {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 100%;
  min-width: 475px;
}

#breadcrumbs {
  width: 100%;
  height: 100%;
  max-height: 50px;
  padding: 0px 24px 0px 24px;
}

#breadcrumbs .v-breadcrumbs,
.v-breadcrumbs--large {
  width: 100%;
  height: 100%;
  border-bottom: solid 1px lightgrey;
}

.v-breadcrumbs__item--disabled {
  color: rgba(0, 0, 0, 0.68) !important;
}

.gradebook-breadcrumbs li {
  height: 40px;
}

.gradebook-breadcrumbs {
  padding: 8px 12px !important;
}
/*Snackbar CSS*/
#snackbar {
  width: 300rem;
  z-index: 100001;
}

#lti {
  z-index: 98;
}

/*Slideout CSS*/
#large-slideout {
  z-index: 100000;
  overflow-y: auto;
  max-width: calc(100% - 80px);
}

.peer-review-slideout {
  background-color: #fff;
  height: 100vh;
  overflow: scroll;
}

.iframe {
  background-color: #fff;
  height: 100vh;
  overflow: hidden;
}

.iframe-fit {
  width: 100%;
  height: calc(100vh - 51px);
}
.slideout-heading {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px 30px;
  width: 100%;
  height: 50px;
}

.slideout-container {
  width: 100%;
  height: calc(100vh - 50px);
}

.slideout-footer {
  display: flex;
  flex-flow: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 50px;
}

.name-text {
  font-size: 1rem;
  color: #858585 !important;
}

.peer-review-table {
  margin-top: 24px;
  width: 100%;
  height: 350px;
  background-color: #fff;
}

.peer-review-table-instructor {
  margin-top: 24px;
  width: 100%;
  height: 250px;
  background-color: #fff;
}

/*Table Toolbar CSS*/
.table-toolbar {
  max-height: 125px;
  display: flex;
  flex-flow: column;
  justify-content: flex-end;
  align-items: space-between;
}

.select-actions {
  width: 100%;
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;
}

.main-toolbar {
  width: 100%;
  min-width: 900px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0px 36px 10px 36px !important;
}

.actions {
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;
}

.filters {
  height: 50px;
  width: 100%;
  padding: 0px 36px 10px 36px !important;
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;
}

.filters-overflow {
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: calc(100% - 72px);
  max-height: 50px;
  overflow-x: auto;
  overflow-y: hidden;
}

.data-manipulation {
  display: flex;
  flex-flow: row;
  justify-content: flex-end;
  align-items: center;
}

.search {
  width: 200px;
  height: 42px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

.search-form {
  width: 200px;
}

.search-form .v-text-field {
  padding-top: 0 !important;
}

.divider-line {
  height: 30px;
  width: 2px;
  border-left: solid 1px lightgrey;
}

.center-btn {
  width: 42px;
  height: 42px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

.v-menu,
.v-menu__activator {
  width: 100% !important;
}

.add-more-options {
  width: 36px;
  height: 36px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin-left: -3px;
  background-color: #fff;
  border: 1px solid var(--branding-active-hex);
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  border-radius: 2px;
}

.add-more-options-disabled {
  width: 36px;
  height: 36px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin-left: -2px;
  background-color: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 2px;
}

.add-more-options i {
  margin-left: 3px;
}

.add-more-menu {
  width: 240px !important;
  background-color: #fff;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.add-more-menu .v-btn__content {
  font-size: 11px !important;
}

.add-learner-menu {
  width: 202px !important;
  min-height: 36px;
  background-color: #fff;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.add-learner-menu button {
  width: 100%;
}

.add-learner-menu .v-btn__content {
  font-size: 14px !important;
  width: 100%;
}

.add-more-sync {
  width: 232px !important;
  height: 36px;
  background-color: #fff;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.add-more-sync button {
  width: 100%;
}

.add-more-sync .v-btn__content {
  font-size: 14px !important;
}

.add-more-instructors {
  width: 200px !important;
  height: 36px;
  background-color: #fff;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.add-more-instructors button {
  width: 100%;
}

.add-more-instructors .v-btn__content {
  font-size: 14px !important;
}

.link-button {
  color: rgba(0, 0, 0, 0.64);
  font-weight: bolder;
  font-size: 15px !important;
}

.archived-classes {
  margin-right: 20px;
}
.archived-classes label {
  font-size: 12px !important;
}

/*bulb settings css*/
.bulb-settings {
  background-color: #fff !important;
}
.bulb-settings-basic {
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 30% 70%;
  padding: 16px;
}
.dropzone {
  padding: 0px !important;
  height: 120px !important;
  min-height: 120px !important;
}
.dz-message {
  margin: 0 !important;
  height: 120px !important;
  width: 200px !important;
}

.dz-message img {
  max-width: 200px !important;
  max-height: 120px !important;
  height: auto;
}

.dz-preview {
  margin: 0 !important;
  height: 120px !important;
  width: 200px !important;
}

.dz-preview img {
  max-width: 200px !important;
  max-height: 120px !important;
  height: auto;
}

.v-autocomplete__content {
  z-index: 100001 !important;
}
.v-input--selection-controls {
  margin-top: 8px !important;
}

.width-small {
  width: 300px;
}

.dz-message .school-branding-preview {
  max-width: 198px !important;
  max-height: 114px !important;
  height: 100%;
}

/*admin css*/
.admin-snapshot-header {
  font-size: 1.5rem;
}

#admin-snapshot canvas {
  min-width: 425px !important;
  height: 350px !important;
}

.admin-header {
  height: 180px;
  width: 100%;
  padding: 24px;
}

.admin-header h4 {
  font-size: 1rem !important;
}

.admin-row {
  display: flex;
  flex-flow: row;
  justify-content: space-around;
  align-items: flex-start;
}

.admin-row-center {
  display: flex;
  flex-flow: row;
  justify-content: space-around;
  align-items: center;
  height: 100%;
}

.admin-container {
  width: 50%;
  min-width: 450px;
}

.admin-list {
  margin: 8px;
  background-color: #fff;
}

.snapshot-card {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

.snapshot-card div {
  width: 100%;
  height: 65px;
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
}

.snapshot-card span {
  font-size: 2rem;
}

.snapshot-card h4 {
  width: 100%;
  text-align: center;
  font-size: 1rem;
}

hr {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.modal-title {
  max-width: 700px;
}

.modal-title span {
  text-overflow: ellipsis;
}

/*smaller phones*/
@media only screen and (min-device-width: 320px) and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  html {
    overflow-y: auto;
  }
  #dash {
    grid-template-columns: 150px auto;
  }

  #breadcrumb-layout {
    height: 40px;
  }

  #tabs-layout {
    height: 40px;
  }

  #main-view {
    min-width: 500px;
  }

  .main-toolbar {
    min-width: 420px;
  }

  .actions {
    min-width: 275px;
  }

  #breadcrumbs {
    max-height: 40px;
    padding: 0px 16px 0px 16px;
  }

  #breadcrumbs ul li {
    font-size: 12px;
  }

  #tabs {
    height: 40px;
    padding: 0px 26px;
  }

  .v-tabs,
  .v-tabs__container {
    height: 40px !important;
  }

  .v-tabs__div {
    font-size: 12px;
  }

  .gradebook-breadcrumbs {
    height: 40px;
  }

  .gradebook-breadcrumbs li {
    font-size: 12px;
  }

  .table-toolbar {
    padding: 0px 16px;
    height: 50px;
  }

  .mobile-height {
    height: 50px !important;
  }

  .select-actions span {
    font-size: 10px;
  }

  .select-actions .v-btn__content {
    font-size: 12px;
  }

  .actions .v-btn__content {
    font-size: 12px;
  }
  .actions span {
    font-size: 10px;
  }
  .actions .v-icon {
    font-size: 16px !important;
  }
  .v-btn {
    padding: 8px;
  }
  .padding-right {
    padding-right: 8px;
  }
  .data-manipulation .v-icon {
    font-size: 16px !important;
  }
  .search {
    width: 120px;
  }
  .search-form {
    width: 100px;
  }
  .search-form label {
    font-size: 12px;
  }
}

/*larger phones*/
@media only screen and (min-device-width: 320px) and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {
  html {
    overflow-y: auto;
  }
  #dash {
    grid-template-columns: 150px auto;
  }

  #breadcrumb-layout {
    height: 40px;
  }

  #tabs-layout {
    height: 40px;
  }

  #main-view {
    min-width: 500px;
  }

  .main-toolbar {
    min-width: 420px;
  }

  .actions {
    min-width: 275px;
  }

  .padding-right {
    padding-right: 8px;
  }
  #breadcrumbs {
    max-height: 40px;
    padding: 0px 16px 0px 16px;
  }

  #breadcrumbs ul li {
    font-size: 14px;
  }

  #tabs {
    height: 40px;
    padding: 0px 26px;
  }

  .v-tabs,
  .v-tabs__container {
    height: 40px !important;
  }

  .v-tabs__div {
    font-size: 12px;
  }
}

/*bulb settings css*/

.dz-message {
  margin: 0 !important;
  height: 120px !important;
  width: 100% !important;
  overflow: hidden;
}

.dz-preview {
  margin: 0 !important;
  height: 120px !important;
  width: 100% !important;
  overflow: hidden;
}

.dz-preview span .responsive-height,
.dz-message span .responsive-height {
  width: 100% !important;
}

.embeddedClass {
  margin-left: 0 !important;
  width: 100vw !important;
}

.embeddedPassbackClass {
  margin-left: 0 !important;
  width: 100vw !important;
}

.googleClassroomStyle {
  margin-left: 0 !important;
  width: 100vw !important;
}

.cell.question-bank-box {
  background: rgba(144, 147, 153, 0.1);
}

.cell.question-bank-box.first-bank-box {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-left: 4px solid #fafafa;
}

.cell.question-bank-box.last-bank-box {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-right: 4px solid #fafafa;
}

.cell.question-bank-box .interaction-question-icon {
  background: transparent;
}

.lmb-private-video-host-content-label-content {
  top: calc(-100% - 10px) !important;
  width: 100% !important;
}

.nudge-top-3px {
  position: relative;
  top: 3px;
}

.grade-number-input {
  .v-input__slot {
    width: 120px;
  }
  .v-input__append-inner {
    line-height: unset !important;
  }
}

// Common styling for our toast
@import '@mixins/Toast/styles.scss';
</style>